export const AURR_LOGIN_SCOPE = ['data:read'];
